/**
 * shadcn/ui (Radix) Bubble, limited to read-only transcript surfaces.
 * https://ui.shadcn.com/docs/components/radix/bubble
 * Re-themed with Admin's neutral surfaces; no interactive or reaction slots.
 */
import type { ComponentProps } from 'react'
import { cn } from './cn'

export function Bubble({ className, variant = 'default', ...props }: ComponentProps<'div'> & { variant?: 'default' | 'secondary' }): JSX.Element {
  return <div data-slot="bubble" data-variant={variant} className={cn('group/bubble relative flex w-fit min-w-0 max-w-full flex-col text-text-primary', className)} {...props} />
}

export function BubbleContent({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return <div data-slot="bubble-content" className={cn('min-w-0 max-w-full rounded-token-card border border-border-default bg-surface-elev px-3 py-2 text-body [overflow-wrap:anywhere] group-data-[variant=secondary]/bubble:bg-surface-app', className)} {...props} />
}
